import React from 'react'
import Img from 'gatsby-image'

import BusinessSection from '@/business-section'
import LargeText from '@/large-text'

const SectionDigitalTools = ({ gray, data }) => {
  return (
    <BusinessSection title="New Digital Tools" gray={gray}>
      <div className="mw800 center">
        <Img sizes={data.digitalTools.sizes} className="mb6" alt="" />

        <div className="tc">
          <LargeText>
            At Next Miss, we focus always to deliver the best possible digital tools for you. All our digital tool are packaged in a format that is easy and fast to start to use. Together as partners we always decide together which tools are suitable for you.
          </LargeText>

          <LargeText>
            We have used years and thousands of long hours to develop the best and most easy to use digital toolkit ever available exclusively to our beauty pageant partners. We pride ourselves about this achievement – and the results speak louder than words.
          </LargeText>

          <LargeText>
            No hassle, no waiting. everything is ready now. Shall you need an online casting tool, most advanced online voting or judge rating tool, we have solutions available for all these categories.
          </LargeText>

          <LargeText>
            As we have experience of helping hundreds of beauty pageants, we can give recommendations which tools to use in your case. Let’s talk, so you can here more about our digital tools.
          </LargeText>
        </div>
      </div>
    </BusinessSection>
  )
}

export default SectionDigitalTools



// WEBPACK FOOTER //
// ./src/components/section-digital-tools/section-digital-tools.js